import styles from './grid.module.scss';
import MaterialGrid from '@mui/material/Grid';

/* eslint-disable-next-line */
export interface GridProps {
  children?: any,
  // classes?: object,
  // columns?: any,
  // columnSpacing?: any,
  // component?: any,
  container?: boolean,
  direction?: 'column-reverse' | 'column' | 'row-reverse' | 'row',
  item?: boolean,
  lg?: 'auto' | any,
  md?: 'auto' | any,
  rowSpacing?: any,
  sm?: 'auto' | number | boolean,
  spacing?: any,
  // sx?: any,
  // wrap?: 'nowrap' | 'wrap-reverse' | 'wrap',
  xl?: 'auto' | any,
  xs?: 'auto' | any,
  zeroMinWidth?: boolean
}

export function Grid(props: GridProps) {
  return (
    <MaterialGrid
      container={props.container}
      spacing={props.spacing}
      item={props.item}
      xs={props.xs}
      sm={props.sm}
      md={props.md}
      lg={props.lg}
      xl={props.xl}
      direction={props.direction}
      rowSpacing={props.rowSpacing}
      zeroMinWidth={props.zeroMinWidth}>
      {props.children}
    </MaterialGrid>
  );
}

export default Grid;